export enum LoadingStates {
  None = 'none',
  Pending = 'pending',
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
}

export const RTW_SYSTEM = 'RTW System';
